<template>
  <div class="geolocation-settings">
    <div class="settings-content">
      <!-- Info Section -->
      <div class="info-section">
        <div class="info-icon">
          <i class="fas fa-info-circle"></i>
        </div>
        <div class="info-text">
          <h4 class="info-title">Sobre a Geolocalização</h4>
          <p class="info-description">
            Ative para permitir que o sistema capture a localização do usuário
            durante o uso da aplicação. Isso melhora a segurança e permite
            auditoria de localização.
          </p>
        </div>
      </div>

      <!-- Settings Section -->
      <div class="settings-section">
        <div class="setting-item">
          <div class="setting-info">
            <div class="setting-icon">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="setting-details">
              <h4 class="setting-title">Geolocalização do Usuário</h4>
              <p class="setting-description">
                Permitir captura de localização em tempo real
              </p>
            </div>
          </div>

          <div class="setting-control">
            <div class="switch-container">
              <label class="switch-modern">
                <input
                  type="checkbox"
                  v-model="check_geolocation"
                  @change="updateUseGeolocation"
                  :disabled="loading"
                />
                <span class="slider-modern">
                  <span class="slider-thumb">
                    <i class="fas fa-check thumb-icon"></i>
                  </span>
                </span>
              </label>
            </div>

            <div class="status-badge">
              <span
                :class="[
                  'badge',
                  check_geolocation ? 'badge-active' : 'badge-inactive',
                ]"
              >
                <i
                  :class="[
                    'fas',
                    check_geolocation ? 'fa-check' : 'fa-times',
                    'badge-icon',
                  ]"
                ></i>
                {{ check_geolocation ? "ATIVO" : "INATIVO" }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Security Notice -->
      <div class="security-notice">
        <div class="notice-icon">
          <i class="fas fa-shield-alt"></i>
        </div>
        <div class="notice-content">
          <h5 class="notice-title">Privacidade e Segurança</h5>
          <p class="notice-text">
            Os dados de localização são utilizados apenas para fins de auditoria
            e segurança. Nenhuma informação é compartilhada com terceiros.
          </p>
        </div>
      </div>

      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p class="loading-text">Atualizando configurações...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "Geolocation",

  components: {},

  props: {
    user_id: {
      type: [Number, String],
    },

    geolocation: {
      type: [Number, String],
    },
  },

  data() {
    return {
      errors: [],
      loading: false,
      check_geolocation: this.geolocation == 1,
    };
  },

  watch: {
    geolocation() {
      this.check_geolocation = this.geolocation == 1;
    },
  },

  created() {},

  methods: {
    formatDate,

    async updateUseGeolocation() {
      try {
        this.loading = true;

        const { user_id, check_geolocation } = this;

        let params = { id: user_id, check_geolocation };

        const response = await api.put(
          "/rest-home/user/use-geolocation",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$emit("save");
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.geolocation-settings {
  position: relative;
  background: white;
  min-height: 400px;
}

.settings-content {
  padding: 32px;
}

/* Info Section */
.info-section {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 16px;
  margin-bottom: 24px;
  border: 1px solid #0ea5e9;
}

.info-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  color: #0c4a6e;
  margin: 0 0 8px 0;
}

.info-description {
  font-size: 14px;
  color: #0369a1;
  margin: 0;
  line-height: 1.5;
}

/* Settings Section */
.settings-section {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
}

.setting-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.setting-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.setting-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}

.setting-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
}

.setting-description {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.setting-control {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

/* Modern Switch */
.switch-modern {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 34px;
  cursor: pointer;
}

.switch-modern input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-modern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #cbd5e1;
  border-radius: 34px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  padding: 2px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.slider-thumb {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(0);
}

.thumb-icon {
  font-size: 12px;
  color: #94a3b8;
  transition: all 0.3s ease;
}

/* Switch Active State */
.switch-modern input:checked + .slider-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.switch-modern input:checked + .slider-modern .slider-thumb {
  transform: translateX(30px);
}

.switch-modern input:checked + .slider-modern .thumb-icon {
  color: #10b981;
}

/* Switch Disabled State */
.switch-modern input:disabled + .slider-modern {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Status Badge */
.status-badge {
  display: flex;
  align-items: center;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.badge-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.badge-inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.badge-icon {
  font-size: 10px;
}

/* Security Notice */
.security-notice {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
  border-radius: 16px;
  border: 1px solid #a855f7;
}

.notice-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #a855f7 0%, #7c3aed 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  flex-shrink: 0;
}

.notice-title {
  font-size: 14px;
  font-weight: 600;
  color: #581c87;
  margin: 0 0 6px 0;
}

.notice-text {
  font-size: 13px;
  color: #6b21a8;
  margin: 0;
  line-height: 1.4;
}

/* Loading Overlay */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 16px;
  z-index: 10;
}

.loading-spinner {
  font-size: 32px;
  color: #8b5cf6;
}

.loading-text {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .settings-content {
    padding: 24px;
  }

  .info-section,
  .settings-section,
  .security-notice {
    padding: 16px;
  }

  .setting-item {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .setting-control {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .info-title,
  .setting-title {
    font-size: 15px;
  }

  .info-description,
  .setting-description {
    font-size: 13px;
  }

  .notice-title {
    font-size: 13px;
  }

  .notice-text {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .settings-content {
    padding: 20px;
  }

  .info-section {
    flex-direction: column;
    text-align: center;
  }

  .security-notice {
    flex-direction: column;
    text-align: center;
  }

  .switch-modern {
    width: 56px;
    height: 30px;
  }

  .slider-thumb {
    width: 26px;
    height: 26px;
  }

  .switch-modern input:checked + .slider-modern .slider-thumb {
    transform: translateX(26px);
  }
}
</style>